import { useSiteContent } from '@/context/SiteContent';
import { Wordmark } from '@/components/yunti/Wordmark';

export function Hero() {
  const { brand, hero } = useSiteContent();
  return (
    <header
      id="hero"
      className="relative bg-yunti-ground text-yunti-ink min-h-[90vh] flex flex-col justify-between px-6 lg:px-12 pt-16 pb-12 overflow-hidden border-b border-yunti-ink/10"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 bg-[radial-gradient(#121212_1px,transparent_1px)] [background-size:32px_32px] opacity-[0.04] pointer-events-none" aria-hidden="true" />

      <div className="max-w-6xl w-full mx-auto flex flex-col md:flex-row md:items-end justify-between gap-6 relative z-10">
        <div className="fade-in-delayed">
          {brand.tagline && (
            <p className="text-xs font-mono uppercase tracking-[0.22em] text-yunti-purple font-semibold">
              {brand.tagline}
            </p>
          )}
          <p className="text-sm text-yunti-ink/60 mt-1 max-w-sm">{brand.intro}</p>
        </div>
        <div className="hidden md:flex items-center gap-4 text-xs font-mono tracking-widest text-yunti-ink/40">
          <span>[ PURPLE = UNIQUE ]</span>
          <span aria-hidden="true">•</span>
          <span>[ DARK GREEN = UNITY ]</span>
        </div>
      </div>

      {/* Kinetic wordmark + mirrored reflection */}
      <div className="max-w-6xl w-full mx-auto my-auto py-12 relative z-10">
        <div className="relative inline-block select-none">
          <h1
            className="text-[clamp(54px,11vw,120px)] font-black uppercase font-display leading-[0.85] tracking-tighter text-yunti-ink"
            data-testid="hero-wordmark"
          >
            <Wordmark text={brand.name} />
          </h1>
          <div
            className="text-[clamp(54px,11vw,120px)] font-black uppercase font-display leading-[0.85] tracking-tighter text-yunti-green/25 transform scale-y-[-1] translate-y-2 blur-[1px] select-none pointer-events-none"
            aria-hidden="true"
            data-testid="hero-wordmark-reflection"
          >
            <Wordmark text={hero.reflection} />
          </div>
        </div>

        <div className="mt-8 space-y-1 text-lg md:text-2xl font-medium tracking-tight text-yunti-ink/90 max-w-xl">
          {hero.lines.map((line, i) => (
            <div className="ln" key={i}>
              <span className={i === hero.lines.length - 1 ? 'text-yunti-purple font-semibold' : undefined}>{line}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 fade-in-delayed">
          <a
            href="#products"
            className="inline-flex items-center gap-4 px-8 py-4 bg-yunti-ink text-yunti-ground text-xs font-mono uppercase tracking-[0.2em] hover:bg-yunti-purple transition-colors group"
            data-testid="shop-perspective-btn"
          >
            <span>{hero.cta}</span>
            <span className="transform group-hover:translate-x-1.5 transition-transform" aria-hidden="true">
              →
            </span>
          </a>
        </div>
      </div>

      <div className="max-w-6xl w-full mx-auto pt-6 border-t border-yunti-ink/10 flex flex-wrap items-center justify-between gap-4 text-xs font-mono text-yunti-ink/60 relative z-10">
        {hero.meta.map((m, i) => (
          <span className="tracking-[0.14em]" key={i}>
            {m}
          </span>
        ))}
      </div>
    </header>
  );
}
